var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.3333L18.15 22.1C18.6978 22.4655 19.3415 22.6605 20 22.6605C20.6585 22.6605 21.3022 22.4655 21.85 22.1L35 13.3333M8.33333 31.6667H31.6667C32.5507 31.6667 33.3986 31.3155 34.0237 30.6904C34.6488 30.0652 35 29.2174 35 28.3333V11.6667C35 10.7826 34.6488 9.93478 34.0237 9.30965C33.3986 8.68453 32.5507 8.33334 31.6667 8.33334H8.33333C7.44928 8.33334 6.60143 8.68453 5.97631 9.30965C5.35119 9.93478 5 10.7826 5 11.6667V28.3333C5 29.2174 5.35119 30.0652 5.97631 30.6904C6.60143 31.3155 7.44928 31.6667 8.33333 31.6667Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailline);
export default __webpack_public_path__ + "static/media/mailline.cc6dc5c453b2189ecbde49b26d693a26.svg";
export { ForwardRef as ReactComponent };